import ChannelConfiguration from 'models/channel_configuration';
import createConverter from 'scripts/adapters/immutable_converters/lib/create_converter';
import createDocumentStoreClass from './lib/create_document_store_class';

const ChannelConfigurationStore = createDocumentStoreClass({
  converter: createConverter(ChannelConfiguration),
});

export default ChannelConfigurationStore;
